import logo from 'assets/header-prevencor-xx.png';
import AssinaturaEletronica from 'components/core/AssinaturaEletronica';
import LaudoActionButtons from 'components/laudos/LaudoActionButtons';
import { Card, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { selectEcoById } from 'services/ecodoppler';
import useSWR from 'swr';
import { generatePDFCongenito } from './generatePDFCongenito';

export default function ReportEcocongenito() {
  const { id } = useParams();
  const {
    data: eco,
    isLoading,
    error,
  } = useSWR(id ? ['ecocongenito', id] : null, () => selectEcoById(id));

  return (
    <Card className="mt-2 mb-2">
      <Card.Header className="text-center font-weight-bold">
        <img
          src={logo}
          alt="Prevencor"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto 8px' }}
          className="no-print"
        />
        LAUDO DE ECOCARDIOGRAMA CONGÊNITO
      </Card.Header>

      {isLoading && (
        <Card.Body>
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Card.Body>
      )}

      {error && !isLoading && (
        <Card.Body className="text-center text-danger py-5">
          {error.message || 'Erro ao carregar o laudo.'}
        </Card.Body>
      )}

      {!isLoading && !error && !eco && (
        <Card.Body className="text-muted text-center py-5">Laudo não encontrado.</Card.Body>
      )}

      {eco && !isLoading && !error && (
        <>
          <Card.Body>
            {eco.TIPOLAUDO === 'Alterado' ? (
              <>
                <strong className="mr-auto">Nome do Paciente: </strong>
                {`${eco.CODPAC} - ${eco.NOMEPAC}`}
                <br />
                <strong className="mr-auto">Data de Nasc: </strong>
                {`${eco.dataNascFmt}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Sexo: </strong>
                {`${eco.Sexo}`}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Idade: </strong>
                {`${eco.idadePAC} anos`}
                <br />
                <strong className="mr-auto">Convênio: </strong>
                {eco.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Cod Eco: </strong>
                {eco.CODECO}&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Data do Exame: </strong>
                {eco.dataEcoFmt}
                <br />
                <strong className="mr-auto">Médico que Realizou: Dr. </strong>
                {`${eco.Realizou}`}
                <br />
                <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
                {`${eco.Solicitou}`}
                <hr />
                <strong className="mr-auto">Observações: </strong>
                {(eco.obs || []).map((obs, index) => (
                  <div key={`obs-${eco.CODECO}-${index}`} className="row">
                    <div className="col-12"> {obs.DESCRICAO}</div>
                  </div>
                ))}
                <br />
                <strong className="mr-auto">
                  Diâmetros e Função Sistólica do Ventrículo Esquerdo{' '}
                </strong>
                <div className="row">
                  <div className="col-6">{`Septo: ${eco.SEPTO?.toFixed(1)} (cm)`}</div>
                  {eco.fracaoEjecaoMono !== null ? (
                    <div className="col-6">{`Fração de Ejeção(Monoplanar): ${eco.fracaoEjecaoMono}`}</div>
                  ) : null}
                </div>
                <div className="row">
                  <div className="col-6">{`PPVE: ${eco.PPVE?.toFixed(1)} (cm)`}</div>
                  {eco.FRAEJECBIPLA !== null ? (
                    <div className="col-6">{`Fração de Ejeção(Simpson): ${eco.FRAEJECBIPLA?.toFixed(2)}`}</div>
                  ) : null}
                </div>
                <div className="row">
                  <div className="col-6">{`Diâmetro Diastólico: ${eco.DD?.toFixed(1)} (cm)`}</div>
                  {eco.massaVE !== null ? (
                    <div className="col-6">{`Massa do VE: ${eco.massaVE} (g/m2)`}</div>
                  ) : null}
                </div>
                <div className="row">
                  {eco.DS !== null ? (
                    <div className="col-6">{`Diâmetro Sistólico: ${eco.DS?.toFixed(1)} (cm)`}</div>
                  ) : null}
                </div>
                <u className="mr-auto">Achados Descritivos do VE: </u>
                {(eco.achados || []).map((achados, index) => (
                  <div key={`achados-${eco.CODECO}-${index}`} className="row">
                    <div className="col-12"> {achados.DESCRICAO}</div>
                  </div>
                ))}
                <br />
                {(eco.contraRegiao || []).length > 0 ? (
                  <>
                    <u className="mr-auto">Contração Segmentar: </u>
                    {eco.contraRegiao.map((contra, index) => (
                      <div key={`contra-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {contra.CONTRASEG}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Átrio Esquerdo e Valva Mitral </strong>
                {eco.DAE !== null ? (
                  <div className="row">
                    <div className="col-12">{`Diâmetro do Átrio Esquerdo: ${eco.DAE?.toFixed(1)} (cm)`}</div>
                  </div>
                ) : null}
                {eco.VOL_AE !== null ? (
                  <div className="row">
                    <div className="col-12">{`Volume do AE: ${eco.VOL_AE?.toFixed(2)} (cc/m2) (até 34)`}</div>
                  </div>
                ) : null}
                {(eco.atrioEsq || []).length > 0 ? (
                  <>
                    {eco.atrioEsq.map((atrioEsq, index) => (
                      <div key={`atrioEsq-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {atrioEsq.DESCRICAO}</div>
                      </div>
                    ))}
                  </>
                ) : null}
                {(eco.valvaMitral || []).length > 0 ? (
                  <>
                    {eco.valvaMitral.map((valvaMitral, index) => (
                      <div key={`valvaMitral-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaMitral.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Valva Aórtica </strong>
                {eco.DAVAO !== null ? (
                  <div className="row">
                    <div className="col-12">{`Diâmetro da Raiz Aórtica: ${eco.DAVAO?.toFixed(1)} (cm)`}</div>
                  </div>
                ) : null}
                {(eco.valvaAO || []).length > 0 ? (
                  <>
                    {eco.valvaAO.map((valvaAO, index) => (
                      <div key={`valvaAO-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaAO.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Aorta </strong>
                {(eco.aorta || []).length > 0 ? (
                  <>
                    {eco.aorta.map((aorta, index) => (
                      <div key={`aorta-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {aorta.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Átrio Direito </strong>
                {(eco.atrioDir || []).length > 0 ? (
                  <>
                    {eco.atrioDir.map((atrioDir, index) => (
                      <div key={`atrioDir-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {atrioDir.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Veia Cava Inferior </strong>
                {(eco.veiaCavaInf || []).length > 0 ? (
                  <>
                    {eco.veiaCavaInf.map((veiaCavaInf, index) => (
                      <div key={`veiaCavaInf-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {veiaCavaInf.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Ventrículo Direito </strong>
                {(eco.ventriDir || []).length > 0 ? (
                  <>
                    {eco.ventriDir.map((ventriDir, index) => (
                      <div key={`ventriDir-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {ventriDir.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Valva Tricúspide</strong>
                {(eco.valvaTricu || []).length > 0 ? (
                  <>
                    {eco.valvaTricu.map((valvaTricu, index) => (
                      <div key={`valvaTricu-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaTricu.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <div className="row">
                  <div className="col-12">
                    <strong className="mr-auto">Valva Pulmonar</strong>
                  </div>
                </div>
                {eco.DAVP !== null ? (
                  <div className="row">
                    <div className="col-12">{`Diâmetro da Anel Pulmonar: ${eco.DAVP?.toFixed(1)} (cm)`}</div>
                  </div>
                ) : null}
                {(eco.valvaPulmo || []).length > 0 ? (
                  <>
                    {eco.valvaPulmo.map((valvaPulmo, index) => (
                      <div key={`valvaPulmo-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaPulmo.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {(eco.pericardio || []).length > 0 ? (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <strong className="mr-auto">Pericárdio</strong>
                      </div>
                    </div>
                    {eco.pericardio.map((pericardio, index) => (
                      <div key={`pericardio-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {pericardio.DESCRICAO}</div>
                      </div>
                    ))}
                  </>
                ) : null}
                <div className="row">
                  <div className="col-12">
                    <p />
                    <strong className="mr-auto">Estudo Congênito</strong>
                  </div>
                </div>
                {(eco.situs || []).length > 0
                  ? eco.situs.map((situs, index) => (
                      <div key={`situs-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {situs.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.septoIA || []).length > 0
                  ? eco.septoIA.map((septoIA, index) => (
                      <div key={`septoIA-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12">
                          {septoIA.DESCRICAO}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {septoIA.MEDIDA !== null ? ` - Valor: ${septoIA.MEDIDA} cm` : ''}
                        </div>
                      </div>
                    ))
                  : null}
                {(eco.septoIV || []).length > 0
                  ? eco.septoIV.map((septoIV, index) => (
                      <div key={`septoIV-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12">
                          {septoIV.septoIV}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {septoIV.MEDIDA !== null ? ` - Valor: ${septoIV.MEDIDA} cm` : ''}
                        </div>
                      </div>
                    ))
                  : null}
                {eco.GVEVD !== null ? (
                  <div className="row">
                    <div className="col-12">
                      {` Estimativa da PSAP: ${eco.estimativaPSVDCong?.toFixed(1)} (mm Hg)           Relação QP/QS: ${eco.relacaoPSCong}`}
                    </div>
                  </div>
                ) : null}
                {(eco.concordAV || []).length > 0
                  ? eco.concordAV.map((concordAV, index) => (
                      <div key={`concordAV-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {concordAV.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.ecoVS || []).length > 0
                  ? eco.ecoVS.map((ecoVS, index) => (
                      <div key={`ecoVS-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {ecoVS.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.concordVA || []).length > 0
                  ? eco.concordVA.map((concordVA, index) => (
                      <div key={`concordVA-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {concordVA.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.artP || []).length > 0
                  ? eco.artP.map((artP, index) => (
                      <div key={`artP-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {artP.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.artC || []).length > 0
                  ? eco.artC.map((artC, index) => (
                      <div key={`artC-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {artC.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.arcoAO || []).length > 0
                  ? eco.arcoAO.map((arcoAO, index) => (
                      <div key={`arcoAO-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {arcoAO.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.conexao || []).length > 0
                  ? eco.conexao.map((conexao, index) => (
                      <div key={`conexao-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {conexao.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.estrutura || []).length > 0
                  ? eco.estrutura.map((estrutura, index) => (
                      <div key={`estrutura-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {estrutura.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {eco.AVM !== null ||
                eco.ORM !== null ||
                eco.GMVM !== null ||
                eco.VOLUME_VM !== null ||
                (eco.refVM || []).length > 0 ? (
                  <div className="row">
                    <div className="col-12">
                      <p />
                      <strong className="mr-auto">Doppler Mitral</strong>
                    </div>
                  </div>
                ) : null}
                <div className="row">
                  {eco.AVM !== null ? (
                    <div className="col-12">{`Área Valva Mitral: ${eco.AVM?.toFixed(1)} (cm2)   ${eco.valorAVM}`}</div>
                  ) : null}
                  {eco.GMVM !== null ? (
                    <div className="col-12">{`Gradiente Médio: ${eco.GMVM} (mmHg)`}</div>
                  ) : null}
                  {eco.RELIMAECLL !== null && !Number.isNaN(eco.RELIMAECLL) ? (
                    <div className="col-12">{`Relação ao Collor IM/AE: ${eco.RELIMAECLL}    ${eco.valorRelacaoIMAECLL}`}</div>
                  ) : null}
                  {eco.orificioRM !== null ? (
                    <div className="col-12">{`Orifício Regurgitação Mitral (PISA): ${eco.orificioRM?.toFixed(2)} (cm2)  ${eco.valorPISA}`}</div>
                  ) : null}
                  {eco.VOLUME_VM !== null ? (
                    <div className="col-12">{`Volume Regurgitação Mitral: ${eco.VOLUME_VM} (cc)`}</div>
                  ) : null}
                  {eco.DAM !== null ? (
                    <div className="col-12">{`Diâmetro do Anel Mitral: ${eco.DAM} (cm)`}</div>
                  ) : null}
                  {eco.FRM !== null && !Number.isNaN(eco.FRM) ? (
                    <div className="col-12">{`Fração da Regurgitação Mitral: ${eco.FRM} (%)        (Normal ou Trivial < 20%)`}</div>
                  ) : null}
                </div>
                {(eco.refVM || []).length > 0 ? (
                  <>
                    {eco.refVM.map((refVM, index) => (
                      <div key={`refVM-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVM.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.AREA_AO !== null ||
                eco.GMVAO !== null ||
                eco.GMVSVE !== null ||
                (eco.refVAO || []).length > 0 ? (
                  <strong className="mr-auto">Doppler Aórtico</strong>
                ) : null}
                {eco.AREA_AO !== null ? (
                  <div className="row">
                    <div className="col-12">{`Área Valva Aórtica: ${eco.AREA_AO?.toFixed(2)} (cm2) ${eco.valorAVAO}`}</div>
                  </div>
                ) : null}
                {eco.FRA !== null && !Number.isNaN(eco.FRA) ? (
                  <div className="col-12">{`Fração da Regurgitação Aórtica: ${eco.FRA} (%)        (Normal ou Trivial < 20%)`}</div>
                ) : null}
                {eco.GMVAO !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Valva Aórtica: ${eco.GMVAO} (mmHg)`}</div>
                  </div>
                ) : null}
                {eco.GMVSVE !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio Via de Saída do VE: ${eco.GMVSVE} (mmHg)`}</div>
                  </div>
                ) : null}
                {eco.RELIAOCLL !== null && !Number.isNaN(eco.RELIAOCLL) ? (
                  <div className="col-12">{`Relação ao Collor da I Aórtica: ${eco.RELIAOCLL}    ${eco.valorRelacaoIAOCLL}`}</div>
                ) : null}
                {(eco.refVAO || []).length > 0 ? (
                  <>
                    {eco.refVAO.map((refVAO, index) => (
                      <div key={`refVAO-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVAO.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.GMVT !== null ||
                eco.estimativaPSVD !== null ||
                (eco.refVT || []).length > 0 ? (
                  <strong className="mr-auto">Doppler Tricúspide</strong>
                ) : null}
                {eco.GMVT !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Valva Tricúspide: ${eco.GMVT} (mmHg)`}</div>
                  </div>
                ) : null}
                {eco.estimativaPSVD !== null ? (
                  <div className="row">
                    <div className="col-12">{`Estimativa da Pressão Sistólica da AP: ${eco.estimativaPSVD} (mmHg)`}</div>
                  </div>
                ) : null}
                {(eco.refVT || []).length > 0 ? (
                  <>
                    {eco.refVT.map((refVT, index) => (
                      <div key={`refVT-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVT.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.GMVP !== null || (eco.refVP || []).length > 0 ? (
                  <strong className="mr-auto">Doppler Pulmonar</strong>
                ) : null}
                {eco.GMVP !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Valva Pulmonar: ${eco.GMVP} (mmHg)`}</div>
                  </div>
                ) : null}
                {(eco.refVP || []).length > 0 ? (
                  <>
                    {eco.refVP.map((refVP, index) => (
                      <div key={`refVP-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVP.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.GMPM !== null || (eco.refluxoPM || []).length > 0 ? (
                  <strong className="mr-auto">Prótese Mitral</strong>
                ) : null}
                {eco.GMPM !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Prótese Mitral: ${eco.GMPM} (mmHg)`}</div>
                  </div>
                ) : null}
                {(eco.refluxoPM || []).length > 0 ? (
                  <>
                    {eco.refluxoPM.map((refluxoPM, index) => (
                      <div key={`refluxoPM-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refluxoPM.refluxoPM}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.GMPAO !== null || (eco.refluxoPAO || []).length > 0 ? (
                  <strong className="mr-auto">Prótese Aórtica</strong>
                ) : null}
                {eco.GMPAO !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Prótese Aórtica: ${eco.GMPAO} (mmHg)`}</div>
                  </div>
                ) : null}
                {(eco.refluxoPAO || []).length > 0 ? (
                  <>
                    {eco.refluxoPAO.map((refluxoPAO, index) => (
                      <div key={`refluxoPAO-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refluxoPAO.refluxoPAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.GMPT !== null || (eco.refluxoPT || []).length > 0 ? (
                  <strong className="mr-auto">Prótese Tricúspide</strong>
                ) : null}
                {eco.GMPT !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Prótese Tricúspide: ${eco.GMPT} (mmHg)`}</div>
                  </div>
                ) : null}
                {(eco.refluxoPT || []).length > 0 ? (
                  <>
                    {eco.refluxoPT.map((refluxoPT, index) => (
                      <div key={`refluxoPT-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refluxoPT.refluxoPT}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {eco.GMPP !== null || (eco.refluxoPP || []).length > 0 ? (
                  <strong className="mr-auto">Prótese Pulmonar</strong>
                ) : null}
                {eco.GMPP !== null ? (
                  <div className="row">
                    <div className="col-12">{`Gradiente Médio da Prótese Pulmonar: ${eco.GMPP} (mmHg)`}</div>
                  </div>
                ) : null}
                {(eco.refluxoPP || []).length > 0 ? (
                  <>
                    {eco.refluxoPP.map((refluxoPP, index) => (
                      <div key={`refluxoPP-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refluxoPP.refluxoPP}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {String(eco.OBSERVACOES || '').trim() !== '' ? (
                  <>
                    <strong className="mr-auto">Observações</strong>
                    <div className="row">
                      <div className="col-12">{eco.OBSERVACOES}</div>
                    </div>
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Conclusões</strong>
                {(eco.valvulopatia || []).length > 0
                  ? eco.valvulopatia.map((valvu, index) => (
                      <div key={`valvu-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvu.valvulopatia}</div>
                      </div>
                    ))
                  : null}
                {(eco.protese || []).length > 0
                  ? eco.protese.map((prot, index) => (
                      <div key={`prot-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {prot.protese}</div>
                      </div>
                    ))
                  : null}
                {(eco.contraSeg || []).length > 0
                  ? eco.contraSeg.map((contra, index) => (
                      <div key={`contraSeg-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {contra.contraSeg}</div>
                      </div>
                    ))
                  : null}
                {(eco.conclusoes || []).length > 0
                  ? eco.conclusoes.map((conclu, index) => (
                      <div key={`conclusoes-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {conclu.conclusoes}</div>
                      </div>
                    ))
                  : null}
              </>
            ) : (
              <>
                <strong className="mr-auto">Nome do Paciente: </strong>
                {`${eco.CODPAC} - ${eco.NOMEPAC}`}
                <br />
                <strong className="mr-auto">Data de Nasc: </strong>
                {`${eco.dataNascFmt}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Sexo: </strong>
                {`${eco.Sexo}`}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Idade: </strong>
                {`${eco.idadePAC} anos`}
                <br />
                <strong className="mr-auto">Convênio: </strong>
                {eco.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Cod Eco: </strong>
                {eco.CODECO}&nbsp;&nbsp;&nbsp;
                <strong className="mr-auto">Data do Exame: </strong>
                {eco.dataEcoFmt}
                <br />
                <strong className="mr-auto">Médico que Realizou: Dr. </strong>
                {`${eco.Realizou}`}
                <br />
                <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
                {`${eco.Solicitou}`}
                <hr />
                {(eco.obs || []).length > 0 ? (
                  <>
                    <strong className="mr-auto">Observações: </strong>
                    {eco.obs.map((obs, index) => (
                      <div key={`obs2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {obs.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <br />
                <strong className="mr-auto">
                  Diâmetros e Função Sistólica do Ventrículo Esquerdo{' '}
                </strong>
                <div className="row">
                  <div className="col-12">{`Septo: ${eco.SEPTO?.toFixed(1)} (cm)`}</div>
                  {eco.fracaoEjecaoMono !== null ? (
                    <div className="col-12">{`Fração de Ejeção(Monoplanar): ${eco.fracaoEjecaoMono}`}</div>
                  ) : null}
                </div>
                <div className="row">
                  <div className="col-12">{`PPVE: ${eco.PPVE?.toFixed(1)} (cm)`}</div>
                </div>
                <div className="row">
                  <div className="col-12">{`Diâmetro Diastólico: ${eco.DD?.toFixed(1)} (cm)`}</div>
                </div>
                <div className="row">
                  <div className="col-12">{`Diâmetro Sistólico: ${eco.DS?.toFixed(1)} (cm)`}</div>
                </div>
                <u className="mr-auto">Achados Descritivos do VE: </u>
                {(eco.achados || []).map((achados, index) => (
                  <div key={`achados2-${eco.CODECO}-${index}`} className="row">
                    <div className="col-12"> {achados.DESCRICAO}</div>
                  </div>
                ))}
                <br />
                {(eco.contraRegiao || []).length > 0 ? (
                  <>
                    <u className="mr-auto">Contração Segmentar: </u>
                    {eco.contraRegiao.map((contra, index) => (
                      <div key={`contra2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {contra.CONTRASEG}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Átrio Esquerdo e Valva Mitral </strong>
                {eco.DAE !== null ? (
                  <div className="row">
                    <div className="col-12">{`Diâmetro do Átrio Esquerdo: ${eco.DAE?.toFixed(1)} (cm)`}</div>
                  </div>
                ) : null}
                {eco.VOL_AE != null ? (
                  <div className="row">
                    <div className="col-12">{`Volume do AE: ${eco.VOL_AE} (cc/m2) (até 34)`}</div>
                  </div>
                ) : null}
                {(eco.atrioEsq || []).length > 0 ? (
                  <>
                    {eco.atrioEsq.map((atrioEsq, index) => (
                      <div key={`atrioEsq2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {atrioEsq.DESCRICAO}</div>
                      </div>
                    ))}
                  </>
                ) : null}
                {(eco.valvaMitral || []).length > 0 ? (
                  <>
                    {eco.valvaMitral.map((valvaMitral, index) => (
                      <div key={`valvaMitral2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaMitral.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Valva Aórtica </strong>
                {eco.DAVAO !== null ? (
                  <div className="row">
                    <div className="col-12">{`Diâmetro da Raiz Aórtica: ${eco.DAVAO?.toFixed(1)} (cm)`}</div>
                  </div>
                ) : null}
                {(eco.valvaAO || []).length > 0 ? (
                  <>
                    {eco.valvaAO.map((valvaAO, index) => (
                      <div key={`valvaAO2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaAO.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Aorta </strong>
                {(eco.aorta || []).length > 0 ? (
                  <>
                    {eco.aorta.map((aorta, index) => (
                      <div key={`aorta2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {aorta.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Átrio Direito </strong>
                {(eco.atrioDir || []).length > 0 ? (
                  <>
                    {eco.atrioDir.map((atrioDir, index) => (
                      <div key={`atrioDir2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {atrioDir.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Ventrículo Direito </strong>
                {(eco.ventriDir || []).length > 0 ? (
                  <>
                    {eco.ventriDir.map((ventriDir, index) => (
                      <div key={`ventriDir2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {ventriDir.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Valva Tricúspide</strong>
                {(eco.valvaTricu || []).length > 0 ? (
                  <>
                    {eco.valvaTricu.map((valvaTricu, index) => (
                      <div key={`valvaTricu2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaTricu.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {(eco.valvaPulmo || []).length > 0 ? (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <strong className="mr-auto">Valva Pulmonar</strong>
                      </div>
                    </div>
                    {eco.valvaPulmo.map((valvaPulmo, index) => (
                      <div key={`valvaPulmo2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {valvaPulmo.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {(eco.pericardio || []).length > 0 ? (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <strong className="mr-auto">Pericárdio</strong>
                      </div>
                    </div>
                    {eco.pericardio.map((pericardio, index) => (
                      <div key={`pericardio2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {pericardio.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                <div className="row">
                  <div className="col-12">
                    <p />
                    <strong className="mr-auto">Estudo Congênito</strong>
                  </div>
                </div>
                {(eco.situs || []).length > 0
                  ? eco.situs.map((situs, index) => (
                      <div key={`situs2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {situs.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.septoIA || []).length > 0
                  ? eco.septoIA.map((septoIA, index) => (
                      <div key={`septoIA2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12">
                          {septoIA.DESCRICAO}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {septoIA.MEDIDA !== null ? ` - Valor: ${septoIA.MEDIDA} cm` : ''}
                        </div>
                      </div>
                    ))
                  : null}
                {(eco.septoIV || []).length > 0
                  ? eco.septoIV.map((septoIV, index) => (
                      <div key={`septoIV2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12">
                          {septoIV.septoIV}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {septoIV.MEDIDA !== null ? ` - Valor: ${septoIV.MEDIDA} cm` : ''}
                        </div>
                      </div>
                    ))
                  : null}
                {eco.GVEVD !== null ? (
                  <div className="row">
                    <div className="col-12">
                      {` Estimativa da PSAP: ${eco.estimativaPSVDCong?.toFixed(1)} (mm Hg)           Relação QP/QS: ${eco.relacaoPSCong}`}
                    </div>
                  </div>
                ) : null}
                {(eco.concordAV || []).length > 0
                  ? eco.concordAV.map((concordAV, index) => (
                      <div key={`concordAV2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {concordAV.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.ecoVS || []).length > 0
                  ? eco.ecoVS.map((ecoVS, index) => (
                      <div key={`ecoVS2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {ecoVS.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.concordVA || []).length > 0
                  ? eco.concordVA.map((concordVA, index) => (
                      <div key={`concordVA2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {concordVA.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.artP || []).length > 0
                  ? eco.artP.map((artP, index) => (
                      <div key={`artP2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {artP.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.artC || []).length > 0
                  ? eco.artC.map((artC, index) => (
                      <div key={`artC2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {artC.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.arcoAO || []).length > 0
                  ? eco.arcoAO.map((arcoAO, index) => (
                      <div key={`arcoAO2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {arcoAO.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.conexao || []).length > 0
                  ? eco.conexao.map((conexao, index) => (
                      <div key={`conexao2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {conexao.DESCRICAO}</div>
                      </div>
                    ))
                  : null}
                {(eco.refVM || []).length > 0 ? (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <p />
                        <strong className="mr-auto">Doppler Mitral</strong>
                      </div>
                    </div>
                    {eco.refVM.map((refVM, index) => (
                      <div key={`refVM2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVM.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {(eco.refVAO || []).length > 0 ? (
                  <>
                    <strong className="mr-auto">Doppler Aórtico</strong>
                    {eco.refVAO.map((refVAO, index) => (
                      <div key={`refVAO2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVAO.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {(eco.refVT || []).length > 0 ? (
                  <>
                    <strong className="mr-auto">Doppler Tricúspide</strong>
                    {eco.refVT.map((refVT, index) => (
                      <div key={`refVT2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVT.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {(eco.refVP || []).length > 0 ? (
                  <>
                    <strong className="mr-auto">Doppler Pulmonar</strong>
                    {eco.refVP.map((refVP, index) => (
                      <div key={`refVP2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {refVP.DESCRICAO}</div>
                      </div>
                    ))}
                    <br />
                  </>
                ) : null}
                {String(eco.OBSERVACOES || '').trim() !== '' ? (
                  <>
                    <strong className="mr-auto">Observações</strong>
                    <div className="row">
                      <div className="col-12">{eco.OBSERVACOES}</div>
                    </div>
                    <br />
                  </>
                ) : null}
                <strong className="mr-auto">Conclusões</strong>
                {(eco.conclusoes || []).length > 0
                  ? eco.conclusoes.map((conclu, index) => (
                      <div key={`conclusoes2-${eco.CODECO}-${index}`} className="row">
                        <div className="col-12"> {conclu.conclusoes}</div>
                      </div>
                    ))
                  : null}
              </>
            )}
          </Card.Body>
          <Card.Footer className="text-center no-print">
            <LaudoActionButtons
              actions={[
                {
                  key: 'timbrado',
                  label: 'Timbrado',
                  onClick: () => generatePDFCongenito({ eco }),
                },
              ]}
            />
          </Card.Footer>
          <Card.Footer className="text-center">
            <AssinaturaEletronica data={eco} nome={eco.Realizou} showPrintButton={false} />
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
